/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Stamp options container.
 *
 * Each named preset (other than `default`) supplies an `apply(element)` that
 * rewrites that host. `amb-stamp` is registered on the host; the slot it
 * replaces is a child. Move this module to `app_honda_cars_base` when a second
 * cartridge needs a stamp preset.
 */
export const stampOptions = {
  default: {},

  /**
   * Clones Callout Badges region HTML from a `<template>`, cycles those Badge
   * children onto sourced labels, and swaps the clone onto the slot.
   */
  callout_badges: {
    /**
     * Stamp sourced labels onto cloned Callout Badges.
     *
     * @param {HTMLElement} element Host carrying `amb-stamp="callout_badges"`.
     */
    apply(element) {
      const slot = element.querySelector('[data-ref="callout-badges"]');
      const templates = element.querySelector('[data-ref="callout-templates"]');
      const labelsEl = element.querySelector('[data-ref="callout-labels"]');

      if (!slot || !templates || !templates.content || !labelsEl) {
        return;
      }

      let labels;

      try {
        labels = JSON.parse(labelsEl.textContent || '[]');
      } catch (error) {
        return;
      }

      if (!Array.isArray(labels) || !labels.length) {
        return;
      }

      const fragment = templates.content.cloneNode(true);
      const region = fragment.querySelector('.region');

      if (!region) {
        return;
      }

      this.stampRegion(region, labels);
      slot.replaceWith(fragment);
      templates.remove();
      labelsEl.remove();
    },

    /**
     * Rebuilds `region` children: one clone per label, cycling the authored
     * Badge nodes. `textContent` replaces Badge copy (including customLabel).
     *
     * @private
     *
     * @param {HTMLElement} region
     * @param {string[]}    labels
     */
    stampRegion(region, labels) {
      const sources = Array.from(region.children);

      if (!sources.length) {
        return;
      }

      const stamped = [];

      for (let i = 0; i < labels.length; i++) {
        stamped.push(this.prepareClone(sources[i % sources.length], labels[i]));
      }

      while (region.firstChild) {
        region.removeChild(region.firstChild);
      }

      for (let j = 0; j < stamped.length; j++) {
        region.appendChild(stamped[j]);
      }
    },

    /**
     * @private
     *
     * @param {Element} source
     * @param {string}  label
     *
     * @returns {Element}
     */
    prepareClone(source, label) {
      const clone = source.cloneNode(true);

      clone.removeAttribute('id');
      clone.textContent = label;

      return clone;
    }
  }
};
